import white from '../../assets/white.png'
import semrush from '../../assets/semrush.png'
import crono from '../../assets/crono.png'
import star from '../../assets/star.png'
import youtube from '../../assets/youtube.png'
import little from '../../assets/little.jpg'
import happy from '../../assets/happy.jpg'
export const data = [
    {
        id:1,
        image:happy,
        title:"Happy Cart",
        github:"https://github.com/Dhanush-Saji/happy-cart",
        live:"https://happycart-official.netlify.app/",
        des:"Happy Cart is a user-friendly e-commerce platform with a secure payment gateway for online shopping.",
        tags:['React JS','Chakra UI','Redux','Stripe','Three JS','Node JS','Mongo DB'],
    },
    {
        id:1,
        image:little,
        title:"The Little AI",
        github:"https://github.com/Dhanush-Saji/The-Little-AI",
        live:"https://the-little-ai.netlify.app/",
        des:"The little AI chatbot comprehends human speech nuances, responds contextually, provides recommendations, and executes tasks - all within the chat interface.",
        tags:['React JS','Chakra UI','CSS','Open AI'],
    },
    {
        id:2,
        image:white,
        title:"White Feather Website",
        github:"https://github.com/Dhanush-Saji/White-Feather-website",
        live:"https://whitefeather.netlify.app/",
        des:"White Feather  is an Indian e-commerce company that sells cosmetics and personal care products.",
        tags:['React JS','Chakra UI','Redux'],
    },
    {
        id:3,
        image:semrush,
        title:"Semrush Website",
        github:"https://github.com/Dhanush-Saji/Semrush-clone",
        live:"https://dhanush-saji.github.io/Semrush-clone/",
        des:"Semrush is a website which offer SEO services, SMM, Content marketing, etc",
        tags:['HTML','JavaScript','CSS'],
    },
    {
        id:4,
        image:crono,
        title:"Cronometer Website",
        github:"https://github.com/Dhanush-Saji/Cronometer-clone",
        live:"https://dhanush-saji-makes-great-sites.netlify.app/",
        des:"Cronomter is a platform to track our health data.",
        tags:['React JS','JavaScript'],
    },
    {
        id:5,
        image:star,
        title:"Star Wars Characters",
        github:"https://github.com/Dhanush-Saji/Star-Wars",
        live:"https://dhanush-saji.github.io/Star-Wars/",
        des:"A website which shows the details of Star Wars characters.",
        tags:['HTML','JavaScript','CSS'],
    },
    {
        id:6,
        image:youtube,
        title:"A mini version of Youtube",
        github:"https://github.com/Dhanush-Saji/Youtube-mini-clone",
        live:"https://dhanush-saji.github.io/Youtube-mini-clone/",
        des:"A website which shows the details of Star Wars characters.",
        tags:['HTML','JavaScript','CSS'],
    }
]